import WorkerApiService from "../workerApiServices"

class ConfiguracaoEmpresaService extends WorkerApiService {

    constructor() {
        super('/api/configuracaoEmpresa')
    }

    search(){
        return this.get(`/search`)
    }


}

export default ConfiguracaoEmpresaService